import { render, staticRenderFns } from "./lista-produtos.vue?vue&type=template&id=62cd380f&"
import script from "./lista-produtos.vue?vue&type=script&lang=js&"
export * from "./lista-produtos.vue?vue&type=script&lang=js&"
import style0 from "./lista-produtos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports